module.exports = __webpack_public_path__ + "img/ltkplussize-2x.dbd1749.jpg";